import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaterGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 125,
	height: 125,
	viewBox: "0 0 125 125",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M79.168 114.583H45.8346C43.2514 114.598 40.7551 113.652 38.8302 111.929C36.9053 110.206 35.6892 107.829 35.418 105.26L26.043 15.625H98.9596L89.5326 105.26C89.2623 107.82 88.0536 110.19 86.1397 111.911C84.2258 113.633 81.7422 114.585 79.168 114.583Z",
		fill: "#E7E9F1",
		stroke: "#E7E9F1",
		strokeWidth: 3.24675,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M69 63.998H63V69.998H61V63.998H55V61.998H61V55.998H63V61.998H69V63.998Z",
		fill: "black"
	})]
});
export default SvgWaterGlass;
